import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { jsx, jsxs } from 'react/jsx-runtime.js';
import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { ThemeColor } from '../../types.js';
import { getSystemColorScheme, getCurrentThemeColor, isDark, updateBodyClass, updateMetaThemeColor, isMatchMediaAvailable } from '../../utils/theme.js';
import { Theme, ThemeContext } from '../ThemeContext.js';
import styles from './ThemeWrapper.module.css.js';

var ThemeWrapper = function ThemeWrapper(props) {
  var children = props.children,
    saveTheme = props.saveTheme,
    getTheme = props.getTheme,
    theme = props.theme;
  var _useState = useState(function () {
      return theme || getTheme() || Theme.auto;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    savedTheme = _useState2[0],
    setSavedTheme = _useState2[1];
  var _useState3 = useState(function () {
      return getSystemColorScheme();
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    systemTheme = _useState4[0],
    setSystemTheme = _useState4[1];
  var currentTheme = getCurrentThemeColor(savedTheme, systemTheme);
  var color = isDark(currentTheme) ? ThemeColor.dark : ThemeColor.light;
  var metaRef = useRef(null);
  useEffect(function () {
    updateBodyClass(currentTheme);
    updateMetaThemeColor(savedTheme, color, metaRef);
  }, [color, currentTheme, savedTheme]);
  useEffect(function () {
    if (!isMatchMediaAvailable()) {
      return;
    }
    var match = window.matchMedia('(prefers-color-scheme: dark)');
    var listener = function listener(e) {
      var newColorScheme = e.matches ? Theme.dark : Theme.light;
      setSystemTheme(newColorScheme);
    };
    match.addEventListener('change', listener);
    return function () {
      match.removeEventListener('change', listener);
    };
  }, []);
  var onThemeChange = useCallback(function (newTheme) {
    saveTheme(newTheme);
    setSavedTheme(newTheme);
  }, [saveTheme]);
  useEffect(function () {
    onThemeChange(savedTheme);
  }, [onThemeChange, savedTheme]);
  var value = useMemo(function () {
    return {
      theme: savedTheme,
      systemTheme: systemTheme,
      onThemeChange: onThemeChange
    };
  }, [onThemeChange, savedTheme, systemTheme]);
  return jsx(ThemeContext.Provider, {
    value: value,
    children: jsxs("div", {
      className: styles.themeContainer,
      children: [jsx("div", {
        className: styles.themeMarker,
        "data-qd-test-theme": currentTheme
      }), children]
    })
  });
};

export { ThemeWrapper };
